import { Injectable } from '@angular/core';

import { Question } from '@app/forms/subscription/definition/interface';
import { CivilStatusQuestionsService } from './civil-status-questions.service';
import { FinancialKnowledgeQustionsService } from './financial-knowledge-qustions.service';
import { ResultTailoredQustionsService } from './result-tailored-qustions.service';
import { RiskProfileQuestionsService } from './risk-profile-questions.service';

@Injectable({
  providedIn: 'root',
})
export class QuestionsDataService {
  constructor(
    private civilStatusQuestionsService: CivilStatusQuestionsService,
    private riskProfileQuestionsService: RiskProfileQuestionsService,
    private financialKnowledgeQustionsService: FinancialKnowledgeQustionsService,
    private resultTailoredQustionsService: ResultTailoredQustionsService,
  ) {}
  civilstatusQustions: Question[] =
    this.civilStatusQuestionsService.civilstatusQustions;
  riskProfileQustions: Question[] =
    this.riskProfileQuestionsService.riskProfileQustions;
  financialKnowledgeQustions: Question[] =
    this.financialKnowledgeQustionsService.financialKnowledgeQustions;
  resultTailoredQustions: Question[] =
    this.resultTailoredQustionsService.resultTailoredQustions;

  questionsSubscription: Question[] = [
    ...this.civilstatusQustions,
    ...this.riskProfileQustions,
    ...this.financialKnowledgeQustions,
    ...this.resultTailoredQustions,
  ];
}
